import { useSelectorKiosk } from "./useSelectorKiosk";

const useViewsConfiguration = () => {
    const selector = useSelectorKiosk(state => state.viewsConfiguration)
    return selector;
}

export default useViewsConfiguration;